import { ReferencedEntry } from 'contentful';

import { ClientConfig, ShopContentType } from 'src/api/contentful/contentTypes.shop';
import { fetchEntries } from 'src/api/contentful/fetchEntries';
import { get, isEntry } from 'src/utils/EntryUtil';
import { Environment } from 'src/utils/Environment';

export async function fetchClientConfig(locale: string, api = Environment.current.shopContentApi) {
  const cookieConfigs = await fetchEntries<ClientConfig>(locale, {
    contentType: ShopContentType.CLIENT_CONFIG,
    include: 2,
  }, api);

  const [ entry ] = get(cookieConfigs, 'items', []);

  return isEntry(entry) ? entry as ReferencedEntry<ClientConfig> : undefined;
}
